function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u692D\u5706\u5F62");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 4
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u5DE5\\u4F5C\\u53F0/\\u89D2\\u8272\\u7BA1\\u7406/\\u5B50\\u8D26\\u53F7",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u4E3B\\u8D26\\u53F7-\\u5DE5\\u4F5C\\u53F001",
  transform: "translate(-1180.000000, -15.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-73",
  transform: "translate(1180.000000, 15.000000)"
}, React.createElement("g", {
  id: "\\u692D\\u5706\\u5F62"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "\\u8499\\u7248",
  fill: "#3BCAC3",
  xlinkHref: "#path-1"
}), React.createElement("ellipse", {
  fill: "#47D3CC",
  mask: "url(#mask-2)",
  cx: 6.5,
  cy: 3,
  rx: 15.5,
  ry: 12
}), React.createElement("ellipse", {
  id: "\\u692D\\u5706\\u5F62\\u590D\\u5236-3",
  fill: "#4FDED7",
  mask: "url(#mask-2)",
  cx: 6.5,
  cy: -1,
  rx: 13,
  ry: 10
}), React.createElement("path", {
  d: "M10.0761225,13.8938457 C10.6543517,13.8938457 11.1236397,14.3656246 11.1236397,14.9469229 C11.1236397,15.5282211 10.6543517,16 10.0761225,16 C9.49789334,16 9.02860536,15.5282211 9.02860536,14.9469229 C9.02860536,14.3656246 9.49789334,13.8938457 10.0761225,13.8938457 Z M10.1925044,4 C12.0308859,4 13.5,5.40248628 13.5,7.45799298 C13.5,8.53650757 13.0318314,9.2217079 11.9192043,10.2993203 C11.7162696,10.4950896 11.6234785,10.5850756 11.5306076,10.6778111 C11.0991048,11.1086849 10.9116224,11.378674 10.878441,11.5819917 L10.8729723,11.6474242 L10.8729723,12.2763151 C10.8729723,12.7609804 10.4821478,13.1538793 10.0000413,13.1538793 C9.55811042,13.1538793 9.1928817,12.8237351 9.13507921,12.3953953 L9.12711038,12.2763151 L9.12711038,11.6474242 C9.12711038,10.8248835 9.51220618,10.2194816 10.3002718,9.43256472 C10.4037061,9.32928123 10.5070731,9.22903907 10.7079061,9.03535195 C11.4883667,8.27945261 11.7541381,7.89047606 11.7541381,7.45799298 C11.7541381,6.39269375 11.0862842,5.75512858 10.1925044,5.75512858 C8.9593628,5.75512858 8.38857489,6.27751991 8.24008609,7.55949347 C8.18432489,8.0409061 7.75091995,8.38572483 7.27204907,8.32966766 C6.79317818,8.27361049 6.45018001,7.83790513 6.50594121,7.3564925 C6.75596793,5.19789447 8.0648405,4 10.1925044,4 Z",
  id: "\\u5F62\\u72B6",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))));

var SvgSubHelp = function SvgSubHelp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subHelp.e51b9c12.svg";
export { ForwardRef as ReactComponent };